(ns dashboard.components.questionnaire.attachments-button
  (:require
   [dashboard.components.attachment-picker :refer [attachment-picker]]
   [dashboard.entity.questionnaire.db :as questionnaire.db]
   [dashboard.ui :as ui]
   [re-frame.core :as rf]))

(defn attachments-button [{:keys [style questionnaire-id question-id answer-id]}]
  (let [linked-attachments @(questionnaire.db/answer-attachments* answer-id)
        tooltip "Attach documents"
        open-notes-modal (fn []
                           (rf/dispatch [::ui/push-modal
                                         {:ctx {:source :answer
                                                :answer-id answer-id
                                                :questionnaire-id questionnaire-id
                                                :question-id question-id}
                                          :component #'attachment-picker
                                          :content-props {:style {:width      "40vw"
                                                                  :min-width  "920px"
                                                                  :min-height "480px"
                                                                  :max-height "80vh"}}}]))]
    [:a.button.is-rounded.is-small.ml-2.is-secondary
     {:style style
      :aria-label tooltip
      :title tooltip
      :on-click open-notes-modal}
     (when-not (empty? linked-attachments)
       [:b (count linked-attachments)])
     [:span.icon>i.fas.fa-paperclip]]))
